var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarcodeScannerBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "40px",
    viewBox: "0 -960 960 960",
    width: "40px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40-120v-188h66.67v121.33H228V-120H40Zm691.33 0v-66.67h121.34V-308h66.66v188h-188Zm-576-114v-492.67h80V-234h-80ZM276-234v-492.67h41.33V-234H276Zm121.33 0v-492.67h82V-234h-82Zm123.34 0v-492.67h120.66V-234H520.67Zm162 0v-492.67H724V-234h-41.33Zm82 0v-492.67h38.66V-234h-38.66ZM40-652v-188h188v66.67H106.67V-652H40Zm812.67 0v-121.33H731.33V-840h188v188h-66.66Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarcodeScannerBlack);
export default __webpack_public_path__ + "static/media/barcode_scanner_black.1b333609d889fc795425cd1037f2e201.svg";
export { ForwardRef as ReactComponent };